import { render, staticRenderFns } from "./DatatableTools.vue?vue&type=template&id=4b1ed9d2&scoped=true&"
import script from "./DatatableTools.vue?vue&type=script&lang=js&"
export * from "./DatatableTools.vue?vue&type=script&lang=js&"
import style0 from "./DatatableTools.vue?vue&type=style&index=0&id=4b1ed9d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1ed9d2",
  null
  
)

export default component.exports